import { FacephiLayoutComponent } from './../layouts/facephi-layout/facephi-layout.component'
import { LoginLayoutComponent } from '../layouts/login-layout/login-layout.component'
import { ControlListLayoutComponent } from '../layouts/control-list-layout/control-list-layout.component'
import { FircLayoutComponent } from '../layouts/firc-layout/firc-layout.component'
import { FiscalLayoutComponent } from '../layouts/fiscal-layout/fiscal-layout.component'
import { OtpLayoutComponent } from '../layouts/otp-layout/otp-layout.component'
import { AuthenticatedGuard } from '../guard/authenticated/authenticated.guard'
import { LoggedGuard } from '../guard/logged/logged.guard'
import { UrlValidatedGuard } from '../guard/url-validated/url-validated.guard'
import { FormCompletedGuard } from '../guard/form-completed/form-completed.guard'
import { SuccessLayoutComponent } from '../layouts/success-layout/success-layout.component'
import { InsuranceLayoutComponent } from '../layouts/insurance-layout/insurance-layout.component'
import { SimulationLayoutComponent } from '../layouts/simulation-layout/simulation-layout.component'
import { SupportLayoutComponent } from '../layouts/support-layout/support-layout.component'
import { DebitCardLayoutComponent } from '../layouts/debit-card-layout/debit-card-layout.component'

export const ListLayout: any = {
  login: LoginLayoutComponent,
  facephi: FacephiLayoutComponent,
  controlList: ControlListLayoutComponent,
  firc: FircLayoutComponent,
  fiscal: FiscalLayoutComponent,
  otp: OtpLayoutComponent,
  success: SuccessLayoutComponent,
  insurance: InsuranceLayoutComponent,
  simulation: SimulationLayoutComponent,
  debitCard: DebitCardLayoutComponent,
  support: SupportLayoutComponent,
  empty: '',
}

export const Guards: any = {
  loggedIn: LoggedGuard,
  authenticated: AuthenticatedGuard,
  urlValidated: UrlValidatedGuard,
  formCompleted: FormCompletedGuard,
}
